export default {
  MEDIUM: 'medium',
  LARGE: 'large',
};
